<div class="" *ngIf='this.offers.offers'>
  <div id="slides_control" class="slides_web">
    <carousel interval="this.myInterval" class="desktop">
      <slide class="panelPaquetes" *ngFor="let offer of this.offers.offers[this.index].offers[0].offersData; let j = index">
        <div class="slides_content pad-change-content">
          <div class="caja-oferta padtop-data" *ngFor="let offerDet of offer.offers ; let k=index">
            <div class="basicrow caja-plan-sug">
              <div class="plandisptitle vcenter">
                <div class="tabcell">
                  ${{offerDet.rent}}
                </div>
              </div>
              <div class="plandispcont">
                <div class="basicrow roboto-b" style="text-align: left;">
                  Descripci&oacute;n del Plan:
                </div>
                <div style="text-align: left;">
                  {{offerDet.typePlan}}
                </div>
                <div class="basicrow m-top-ii">
                  <div class="redstat rblack m-top-u" *ngFor="let description of offerDet.descriptions.descriptions; let n = index">
                    {{description.description}}
                  </div>
                </div>
                <div class="basicrow m-top-ii">
                  <div class="logline full"></div>
                </div>
                <div class="basicrow text-center m-top">
                  <div class="servs-plans">
                    <a (click)="this.changePlanBtn(offerDet.id,this.commitmentOriginalMonths,offerDet.typePlan,offerDet.descriptions.descriptions, offerDet.rent, offerDet.soc,offerDet.customerSubtype,offerDet.customerType)" class="btns red vcenter">
                                            <span class="tabcell">
                                              Escoger&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                                            </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </slide>
    </carousel>
  </div>
  <div class="basicrow  allpads  f-reg roboto-r f-black text-justify ajusteMsjError" style="font-size:16px" *ngIf="this.offers.offers[this.index].offers[0].offersData==''">
    Estimado cliente en estos momentos no tenemos planes para este suscriptor.
  </div>

  <div>
    <!--
    <mat-carousel
      *ngIf='this.offers.offers'
      color="accent"
      maxWidth="auto"
      slideHeight="120%"
      proportion="25"
      slides="5"
      [loop]="true"
      [hideArrows]="false"
      [hideIndicators]="true"
      [useKeyboard]="true"
      [useMouseWheel]="false"
      proportion="35"
      orientation="ltr"
      class="desktop"

    >
      <mat-carousel-slide
        #matCarouselSlide
        *ngFor="let offer of this.offers.offers[this.index].offers[0].offersData; let j = index"
        overlayColor="#00000040"
        [hideOverlay]="false"
      >
        <div class="slides_content pad-change-content" style="height: 420px !important;">
          <div class="caja-oferta padtop-data" *ngFor="let offerDet of offer.offers ; let k=index">
            <div class="basicrow caja-plan-sug">
              <div class="plandisptitle vcenter">
                <div class="tabcell">
                  ${{offerDet.rent}}
                </div>
              </div>
              <div class="plandispcont">
                <div class="basicrow roboto-b" style="text-align: left;">
                  Descripci&oacute;n del Plan:
                </div>
                <div style="text-align: left;">
                  {{offerDet.typePlan}}
                </div>
                <div class="basicrow m-top-ii">
                  <div class="redstat rblack m-top-u" *ngFor="let description of offerDet.descriptions.descriptions; let n = index">
                    {{description.description}}
                  </div>
                </div>
                <div class="basicrow m-top-ii">
                  <div class="logline full"></div>
                </div>
                <div class="basicrow text-center m-top">
                  <div class="servs-plans">
                    <a (click)="this.changePlanBtn(offerDet.id,this.commitmentOriginalMonths,offerDet.typePlan,offerDet.descriptions.descriptions, offerDet.rent, offerDet.soc,offerDet.customerSubtype,offerDet.customerType)" class="btns red vcenter">
                                          <span class="tabcell">
                                            Escoger&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                                          </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-carousel-slide>

    </mat-carousel>
    --->
    <mat-carousel
      *ngIf='this.offers.offers'
      color="accent"
      maxWidth="auto"
      slideHeight="420px"
      proportion="25"
      slides="5"
      [loop]="true"
      [hideArrows]="false"
      [hideIndicators]="true"
      [useKeyboard]="true"
      [useMouseWheel]="false"
      proportion="35"
      orientation="ltr"
      class="movil"
      [maintainAspectRatio]="false"
      [autoplay]="false"
    >
      <mat-carousel-slide
        #matCarouselSlide
        *ngFor="let offerDet of this.auxList; let j = index"
        overlayColor="#f2f2f2"
        [hideOverlay]="false"
      >
        <div class="slides_content pad-change-content">
          <div class="caja-oferta padtop-data">
            <div class="basicrow caja-plan-sug">
              <div class="plandisptitle vcenter">
                <div class="tabcell">
                  ${{offerDet.rent}}
                </div>
              </div>
              <div class="plandispcont">
                <div class="basicrow roboto-b" style="text-align: left;">
                  Descripci&oacute;n del Plan:
                </div>
                <div style="text-align: left;">
                  {{offerDet.typePlan}}
                </div>
                <div class="basicrow m-top-ii">
                  <div class="redstat rblack m-top-u" *ngFor="let description of offerDet.descriptions.descriptions; let n = index">
                    {{description.description}}
                  </div>
                </div>
                <div class="basicrow m-top-ii">
                  <div class="logline full"></div>
                </div>
                <div class="basicrow text-center m-top">
                  <div class="servs-plans">
                    <a (click)="this.changePlanBtn(offerDet.id,this.commitmentOriginalMonths,offerDet.typePlan,offerDet.descriptions.descriptions, offerDet.rent, offerDet.soc,offerDet.customerSubtype,offerDet.customerType)" class="btns red vcenter">
                                            <span class="tabcell">
                                              Escoger&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
                                            </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </mat-carousel-slide>

    </mat-carousel>

  </div>


</div>


